import React, { FC } from 'react';

const IconCar: FC = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" {...props}>
      <path
        fillRule="evenodd"
        d="M5.4,14.4 C4.41,14.4 3.6,15.21 3.6,16.2 C3.6,17.19 4.41,18 5.4,18 C6.39,18 7.2,17.19 7.2,16.2 C7.2,15.21 6.39,14.4 5.4,14.4 L5.4,14.4 Z M0,0 L0,1.8 L1.8,1.8 L5.04,8.64 L3.78,10.8 C3.69,11.07 3.6,11.43 3.6,11.7 C3.6,12.69 4.41,13.5 5.4,13.5 L16.2,13.5 L16.2,11.7 L5.76,11.7 C5.67,11.7 5.58,11.61 5.58,11.52 L5.58,11.43 L6.39,9.9 L13.05,9.9 C13.77,9.9 14.31,9.54 14.58,9 L17.82,3.15 C18,2.97 18,2.88 18,2.7 C18,2.16 17.64,1.8 17.1,1.8 L3.78,1.8 L2.97,0 L0,0 L0,0 Z M14.4,14.4 C13.41,14.4 12.6,15.21 12.6,16.2 C12.6,17.19 13.41,18 14.4,18 C15.39,18 16.2,17.19 16.2,16.2 C16.2,15.21 15.39,14.4 14.4,14.4 L14.4,14.4 Z"
      />
    </svg>
  );
};

export default IconCar;
